export default {
    downloadMaintenanceFiles: "/maintenance/downloadFiles",
    //table list
    MaintenanceShow: "/maintenance/show",
    // MaintenanceHistory列表
    MaintenanceShowHistory: "/maintenance/showHistory",
    //tableAdd
    MaintenanceAdd: "/maintenance/add",
    // 上传图片
    UploadFile: "/maintenance/uploadFile",
    // tableUpdate
    MaintenanceUpdate: "/maintenance/update",
    //tableDelete
    MaintenanceDel: "/maintenance/delete",
    // Maintenance 下载
    MaintenanceToExcel: "/maintenance/export/excel",
    // 通过工单id展示材料列表
    showMaterialsByMaintenanceId: "/maintenance/showMaterialsByMaintenanceId",
    // 审批材料
    reviewMaterials: "/maintenance/reviewMaterials",
    // 管理员展示当前工单的打卡记录
    getClockList: "/maintenance/process/showClockList",
    //user info
    UserInfo: "/maintenance/delete",
    //查看工单流程
    process: "/maintenance/process/show",
    // 新增查询数据
    getIdDetails: "/maintenance/showById",
    //工单流程第一步：添加图片
    addFileTo1: "/maintenance/process/addFileTo1",
    //工单流程第二步：选择是否维修
    addTo2: "/maintenance/process/addTo2",
    //工单流程第三步：选择维修人员
    addTo3: "/maintenance/process/addTo3",
    //工单流程第四步：查看维修人员备注
    updateTo4: "/maintenance/process/updateTo4",
    //工单流程第五步：确认维修后的效果
    updateTo5: "/maintenance/process/updateTo5",
    // 根据utiid查询requestBy
    requestByType: "/maintenance/getRequestByNameByUnitId",
    // Non open 分页查询
    onpenMaintenanceShow: "/maintenance/non/show",
    // Non新增
    addMaintenanceNon: "/maintenance/non/add",
    // NON  complete request
    completeRequestData: "/maintenance/non/updateStatus",
    // NON 指定人员
    getUpdate: "/maintenance/non/update",
    // NON 详情获取资源
    showDetail: "/maintenance/non/showDetail",
    // 详情页面回退
    rollbackProcess: "/maintenance/process/rollbackProcess",
    // NON 发送邮件
    getToEamil: "/maintenance/non/sendEmail",
    //   NON 下载页面数据
    getToExcel: "/maintenance/non/export/excel",
    // MonthlyWorkerShow   --甘特图数据
    showMonthlyWorker: "/maintenance/monthlyWorker/show",
    // MonthlyWorker Charts图表数据 --打卡数据显示
    getVendorShowClock: "/maintenance/vendorClock/showClock",
    // Vendor Clock 维修工打卡记录
    getVendorClockShow: "/maintenance/vendorClock/show",
    // 管理员给维修进行补卡
    getVendorClockAdd: "/maintenance/vendorClock/add",
    // 打卡付款记录展示
    getclockPayRecordShow: "/maintenance/clockPayRecord/show",
    // 打卡记录详情
    getDetailById: "/maintenance/clockPayRecord/getDetailById",
    // 手动推送账单
    getManualToPay: "/maintenance/vendorClock/manualToPay",
    // 获取ReportList
    getReportList:"/maintenance/getReportList",
    // 获取report 总数  旧接口
    getAllReport:"/maintenance/getAllReport",
    // non maintenance details 追加文件上传功能
    getNonMaintenanceAddFiles:"/maintenance/non/addFiles",
    // 获取Supervisor列表
    getSupervisorList:"/accountSupervisor/getSupervisorList",
        // 获取ready to pay maintace report  旧接口
    getReadyReportList:"/maintenance/getReadyReportList",
    // 查询一次性付款的数据
    getPayContractorShow:"/maintenance/pay/contractor/show",
    // 修改一次性付款的数据
    getPayContractorUpdate:"/maintenance/pay/contractor/update",
    // contractor推账单
    saveContractorPayment:"/maintenance/pay/contractor/saveContractorPayment",
    // 修改contractor 推账单
    getToVendorPayment:"/maintenance/pay/contractor/sendToVendorPayment",
    // 查询正式工月付的数据
    getMonthlyWorkerPaymentShow:"/maintenance/pay/monthlyWorker/show",
    // 查询正式工月付详情数据
    getShowDetail:"/maintenance/pay/monthlyWorker/showDetail",
    // 查询支付周期列表
    getPeriodList:"/maintenance/pay/monthlyWorker/getPeriod",
    // 推送正式账单
    getSendToVendorPayment:"/maintenance/pay/monthlyWorker/sendToVendorPayment",
    // 获取GL_Account数据
    getGLAccountList:"/maintenance/pay/contractor/getGlAcctList",
    // 给数据添加GLACCt
    getAddGlAcctToInfo:"/maintenance/pay/contractor/saveGlAcctToInfo",
    // 修改一次性付款金额
    getUpdatePayAmount:"/maintenance/pay/contractor/updatePayAmount",
    // 历史工单Excel下载
    getHistoryToExcel:"/maintenance/exportHistory/excel",
    // vendor 打卡详情
    getVendorShowClock:"/maintenance/vendorClock/showClock",
    // 根据PropUnitTenant 关联查询
    getShowPut:"/maintenance/showPUT",
    // 根据propUnitTenant 关联查询
    getContractorShow:"/maintenance/pay/contractor/showPUT",
    // 根据ID查看工单详情
    getShowDetailByMaintenanceId:"/maintenance/process/showDetailByMaintenanceId",
    // 推送正式工的数据到维修工合同
    getAddContractorPayAndChangeMWT:"/maintenance/history/addContractorPayAndChageMWT"
};
